import {
  CardActions,
  CardContent,
  CardHeader,
  Dialog,
  FormControl,
  FormHelperText,
  Grid,
  Paper,
  TextField,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import AppButton from "../../../shares/AppButton";
const INIT_DOMAINE_COMPETENCE = {
  id_experience: null,
  id_identite: null,
  date_debut_experience: null,
  date_fin_experience: null,
  organisme_experience: null,
  domaine_experience: null,
  sous_domaine_experience: null,
  statut: null,
  experience_mission: null,
  description_experience: null,
  reference: null,
  email_ref: null,
  num_ref: null,
  file_experience: null,
  fin_contrat: null,
};
const INIT_FORM_ERROR = {
  date_debut_experience_error: null,
  date_fin_experience_error: null,
  organisme_experience_error: null,
  domaine_experience_error: null,
  sous_domaine_experience_error: null,
  statut_error: null,
  experience_mission_error: null,
  description_experience_error: null,
  reference_error: null,
  email_ref_error: null,
  num_ref_error: null,
  file_experience_error: null,
  fin_contrat_error: null,
};
const DomaineCompetenceForm = ({
  open,
  onFormClose,
  onFormOpen,
  idCompetence,
}) => {
  const [currentCompetence, setCurrentCompetence] = useState(
    INIT_DOMAINE_COMPETENCE
  );
  const [formErrors, setFormErrors] = useState(INIT_FORM_ERROR);
  const handleFormClose = () => {
    onFormClose();
  };

  const handleAnneeChange = (event) => {
    let annee = event.target.value;
    const currentYear = new Date().getFullYear();
    if (annee > currentYear) {
      setFormErrors((prevErrors) => ({
        ...prevErrors,
        annee: "L'année ne peut pas dépasser l'année courrante",
      }));
      event.target.value = currentYear;
    } else {
      setFormErrors((prevErrors) => ({ ...prevErrors, annee: "" }));
    }
  };

  const handleChangeCurrentCompetence = (event) => {
    const { name, value } = event.target;
    setCurrentCompetence((prevCompetence) => ({
      ...prevCompetence,
      [name]: value,
    }));
  };

  const handleCheckError = () => {
    setFormErrors({
      date_debut_experience_error: !currentCompetence.date_debut_experience
        ? "Date de debut est requis"
        : null,
      date_fin_experience_error: !currentCompetence.date_fin_experience
        ? "Date de fin est requis"
        : null,
      organisme_experience_error: !currentCompetence.organisme_experience
        ? "Organisme est requis"
        : null,
      domaine_experience_error: !currentCompetence.domaine_experience
        ? "Domaine est requis"
        : null,
      sous_domaine_experience_error: !currentCompetence.sous_domaine_experience
        ? "Sous domaine est requis"
        : null,
      statut_error: !currentCompetence.statut ? "Statut est requis" : null,
      experience_mission_error: !currentCompetence.experience_mission
        ? "Mission est requise"
        : null,
      description_experience_error: !currentCompetence.description_experience
        ? "Description est requise"
        : null,
      reference_error: !currentCompetence.reference
        ? "Reference est requise"
        : null,
      email_ref_error: !currentCompetence.email_ref
        ? "Email de reference est requise"
        : null,
      num_ref_error: !currentCompetence.num_ref
        ? "Num de reference est requise"
        : null,
      file_experience_error: !currentCompetence.file_experience
        ? "Fichier est requis"
        : null,
      fin_contrat_error: !currentCompetence.fin_contrat
        ? "Date de fin de contrat est requise"
        : null,
    });
    return Object.values(formErrors).every((error) => error === null);
  };

  useEffect(() => {
    handleCheckError();
  }, [currentCompetence]);

  return (
    <Dialog open={open} onClose={handleFormClose} fullWidth maxWidth="xs">
      <Paper sx={{ m: 3 }} elevation={0}>
        <Grid>
          <CardHeader title="Domaine de competence" />
          <CardContent>
            <Grid container>
              <FormControl fullWidth>
                <label>Domaine de competence *</label>
                <TextField
                  id="diplome"
                  name="diplome"
                  onChange={handleAnneeChange}
                  size="small"
                  placeholder="Diplôme obtenu"
                  fullWidth
                  //  // value={currentDemande.EMAILS}
                  //   error={formError.EMAILS && isSubmitted()}
                  //   helperText={formError.EMAILS}
                  aria-describedby="nom_helper"
                />
                <FormHelperText id="nom_helper"></FormHelperText>
              </FormControl>
              <FormControl fullWidth>
                <label>Sous domaine de competence *</label>
                <TextField
                  id="etablissement"
                  name="etablissement"
                  onChange={handleAnneeChange}
                  size="small"
                  placeholder="Etablissement"
                  fullWidth
                  //  // value={currentDemande.EMAILS}
                  //   error={formError.EMAILS && isSubmitted()}
                  //   helperText={formError.EMAILS}
                  aria-describedby="nom_helper"
                />
                <FormHelperText id="nom_helper"></FormHelperText>
              </FormControl>
            </Grid>
          </CardContent>
          <CardActions sx={{ justifyContent: "flex-end" }}>
            <AppButton text={"Enregistrer"} size={"medium"} variant={"contained"} />
            <AppButton text={"Fermer"} size={"medium"} variant={"outlined"} />
          </CardActions>
        </Grid>
      </Paper>
    </Dialog>
  );
};

export default DomaineCompetenceForm;
